<sw-page class="tdcp-customer-price-detail">
    <template #smart-bar-header>
        <h2>{{ $tc('tdcp-customer-prices.detail.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onBack">
            {{ $tc('tdcp-customer-prices.detail.label.backToList') }}
        </sw-button>
    </template>

    <template #content>
        <sw-card-group v-if="item">
            <sw-card :title="$tc('tdcp-customer-prices.detail.card.priceInfo')"
                     :isLoading="isLoading">
                <sw-description-list>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.basePrice') }}</dt>
                    <dd>{{ formatPrice(item.price) }}</dd>
                </sw-description-list>
            </sw-card>

            <sw-card :title="$tc('tdcp-customer-prices.detail.card.productInfo')"
                     :isLoading="isLoading">
                <sw-description-list>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.productNumber') }}</dt>
                    <dd>{{ item.product ? item.product.productNumber : '-' }}</dd>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.productName') }}</dt>
                    <dd>{{ item.product ? item.product.name : '-' }}</dd>
                </sw-description-list>
            </sw-card>

            <sw-card :title="$tc('tdcp-customer-prices.detail.card.customerInfo')"
                     :isLoading="isLoading">
                <sw-description-list>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.customerNumber') }}</dt>
                    <dd>{{ item.customer ? item.customer.customerNumber : '-' }}</dd>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.customerName') }}</dt>
                    <dd>{{ item.customer ? item.customer.firstName + ' ' + item.customer.lastName : '-' }}</dd>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.customerEmail') }}</dt>
                    <dd>{{ item.customer ? item.customer.email : '-' }}</dd>
                    <dt>{{ $tc('tdcp-customer-prices.detail.label.customerCompany') }}</dt>
                    <dd>{{ item.customer ? item.customer.company : '-' }}</dd>
                </sw-description-list>
            </sw-card>

            <sw-card :title="$tc('tdcp-customer-prices.detail.card.graduatedPrices')"
                     :isLoading="isLoading">
                <template v-if="item.graduatedPrices && item.graduatedPrices.length > 0">
                    <sw-data-grid
                        :dataSource="item.graduatedPrices"
                        :columns="graduatedPriceColumns"
                        :show-selection="false"
                        :show-actions="false"
                        :compact-mode="true"
                    >
                        <template #column-price="{ item: graduatedItem }">
                            {{ formatGraduatedPrice(graduatedItem.price) }}
                        </template>
                    </sw-data-grid>
                </template>
                <template v-else>
                    <p>{{ $tc('tdcp-customer-prices.detail.label.noGraduatedPrices') }}</p>
                </template>
            </sw-card>
        </sw-card-group>

        <sw-loader v-if="isLoading && !item" />

        <sw-empty-state
            v-if="!isLoading && !item"
            :title="$tc('tdcp-customer-prices.detail.title')"
            icon="regular-currency-euro"
        />
    </template>
</sw-page>
